export const faqData = [
  {
    question: '韩漫大全网站上的所有漫画都是免费的吗？',
    answer: '是的！韩漫大全网站上所有韩国漫画内容完全免费提供，无需付费或订阅。我们致力于为韩漫爱好者打造一个开放、免费的阅读平台，让每一位读者都能畅享韩国漫画的魅力。我们通过广告收入维持运营，绝不会向用户收取任何费用。',
  },
  {
    question: '什么是下拉式阅读？如何使用下拉式阅读功能？',
    answer: '下拉式阅读是一种专为手机和网页优化的漫画阅读方式。读者只需向下滑动页面，漫画内容就会连续展示，无需翻页点击。这种方式模拟了在社交媒体上浏览内容的体验，让阅读更加流畅自然。在韩漫大全，所有漫画都支持下拉式阅读，为您带来最佳的阅读体验。',
  },
  {
    question: '网站上的漫画是否有删减？',
    answer: '韩漫大全坚持提供无删减的韩国漫画内容。我们尊重原作者的创作意图，保留漫画中的所有情节和画面，让读者能够完整体验每一部漫画的精彩。我们与多家韩国漫画平台保持合作，确保内容的完整性和正版授权。',
  },
  {
    question: '韩漫大全多久更新一次漫画？',
    answer: '我们团队每天都会更新漫画内容。热门连载漫画通常会在韩国发布后的24小时内更新中文版本。您可以关注首页的"最新更新"板块，或者订阅我们的通知，第一时间获取最新漫画章节。',
  },
  {
    question: '如何在手机上阅读韩漫？',
    answer: '韩漫大全网站采用响应式设计，完美适配手机、平板和电脑等各类设备。您只需在手机浏览器中打开我们的网址，即可享受优化的移动端阅读体验。下拉式阅读在手机上尤其方便，单手操作即可轻松浏览所有内容。',
  },
  {
    question: '如何找到我想看的漫画类型？',
    answer: '您可以通过首页的分类导航找到感兴趣的漫画类型，包括恋爱漫画、奇幻冒险、动作热血、悬疑惊悚、搞笑日常、BL漫画和GL漫画等。也可以使用搜索功能直接查找漫画名称，或者浏览热门推荐榜单发现优质作品。',
  },
  {
    question: '网站支持哪些语言？',
    answer: '目前韩漫大全主要提供简体中文版本。我们的翻译团队由资深的韩语翻译人员组成，力求准确传达原作的情感和细节。未来我们计划推出繁体中文和英文版本，服务更多漫画爱好者。',
  },
  {
    question: '遇到网站问题或想反馈意见，如何联系你们？',
    answer: '您可以通过"关于我们"页面的联系方式与我们取得联系，包括电子邮件和在线反馈表单。我们非常重视每一位用户的意见和建议，客服团队会在24小时内回复您的留言。',
  },
];